import * as React from 'react'
export const Mf = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108 72" width="1em" height="1em" {...props}>
    <path fill="#003787" d="M0 0h108v72H0z" />
    <path fill="#fff" d="M0 0h108L60 48v24H48V48z" />
    <circle cx={54} cy={30} r={8} fill="#f9d90f" />
    <path fill="#fff" d="M44 30h20L54 48z" />
    <path fill="#cf142b" d="M54 48 38 33h32z" />
  </svg>
)
